import React from "react";
import {
  Button,
  ContainerForm,
  ContainerText,
  Input,
  TextHead,
  TextRegular,
} from "./CardInfo.styled";
import { func } from "../../../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import Show from "../../../atoms/Show/Show";

const CardInfo = ({ city }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const actionWording = location?.state?.action ?? "registrasi";
  const isRegistration = actionWording === "registrasi";

  const handleClick = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center gap-[16vh]">
      <ContainerForm>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <ContainerText>
            <img
              src={func.getStaticImg("/illustration/warning-icon.svg")}
              alt="success-regist"
              style={{ width: 53, height: 53 }}
            />
            <div>
              <Show when={actionWording === "add-player"}>
                <TextRegular
                  fontSize={"16px"}
                  style={{ fontWeight: "bold", marginBottom: 8 }}
                >
                  Cek dan Ketahui Jadwal Tim Kamu
                </TextRegular>
                <TextRegular fontSize="12px" className="mt-2">
                  Pastikan kamu mengetahui kapan tim kamu akan bertanding.
                </TextRegular>
              </Show>
              <Show when={actionWording !== "add-player"}>
                <TextRegular style={{ fontWeight: "bold", marginBottom: 8 }}>
                  Data sekolahmu sudah {isRegistration ? "masuk" : "terupdate"}
                </TextRegular>
                <TextRegular fontSize="12px" className="mt-2">
                  Untuk pengumuman peserta piala by.U {city} dapat dilihat di
                  Dashboard
                </TextRegular>
              </Show>
            </div>
          </ContainerText>
        </div>
      </ContainerForm>
      <Button onClick={handleClick}>Lihat Dashboard</Button>
    </div>
  );
};

export default CardInfo;
